import http from '../http'
import { Res } from '../type'
import { MessageIndexList, MessageIndexCount, MessageListParams, MessageList } from '../Models/MessageIndexList'
import { MessageDetail, MessageDetailParams } from '../Models/MessageDetail'

// 站内信/通知中心相关接口

// 消息中心-查询列表
export const getMessageIndexList = (): Res<MessageIndexList> => {
  return http.request({
    url: '/sands-system/api/v1/message/listCenter',
    method: 'GET',
    toastShow: '0'
  })
}

export const getMessageUnreadCount = (): Res<MessageIndexCount> => {
  return http.request({
    url: '/sands-system/api/v1/message/getUnreadCount',
    method: 'GET'
  })
}

export const clearMsgUnreadCount = (): Res<MessageIndexCount> => {
  return http.request({
    url: '/sands-system/api/v1/message/readAll',
    method: 'POST'
  })
}

// 站内信相关接口-查询消息(分页)
export const getMessageList = (params: MessageListParams): Res<MessageList> => {
  return http.request({
    url: '/sands-system/api/v1/message/page',
    method: 'POST',
    data: params,
    loadingShow: params.loadingShow as '0' | '1' | undefined
  })
}

// 站内信相关接口-消息详情
export const getMessageDetail = (params: MessageDetailParams): Res<MessageDetail> => {
  return http.request({
    url: '/sands-system/api/v1/message/get',
    method: 'GET',
    params
  })
}

// ceo反馈详情
export const getCeoDetail = (params: MessageDetailParams): Res<MessageDetail> => {
  return http.request({
    url: '/sands-lms/api/v1/ceo-channel/get',
    method: 'get',
    params,
    loadingShow: '0'
  })
}
